import React from 'react';
interface PageHeaderProps {
  title: string;
  lede: React.ReactNode;
  children?: React.ReactNode;
}
export function PageHeader({
  title,
  lede,
  children
}: PageHeaderProps) {
  return <header className="border-b border-line" data-id="element-390" data-mp="3rec9tt7i93kn">
      <div className="mx-auto max-w-[1400px] px-5 pb-8 pt-10 md:px-8 md:pt-14" data-id="element-391" data-mp="3re3ulunwtm6a">
        <h1 className="font-serif text-4xl leading-[1.05] text-ink md:text-[3.25rem]" data-id="element-392" data-mp="3mgkcuks06r9l">{title}</h1>
        <p className="mt-4 max-w-2xl text-[15px] leading-relaxed text-muted md:text-base" data-id="element-393" data-mp="2yqzsbxg7bly7">{lede}</p>
        {children && <div className="mt-6 flex flex-wrap items-center gap-2" data-id="element-394" data-mp="2tseta1cor8bc">{children}</div>}
      </div>
    </header>;
}